export const defaultState = () => ({
	step: 0,
	forward: true,
	complete: false,
	extraFeatures: ['wpforms', 'google-analytics', 'seo', 'social-proof', 'landing-pages'],
});

const state = defaultState();

export default state;
